import React, { PropTypes } from 'react'
import css from './style.scss'

const InstitutionHero = ({ logoUrl, institutionName, branding = {}, showInstitutionName, poweredByText }) => {
  const displayName = showInstitutionName !== false
  const { navBackground, navIsLight, ncfddLogo, navLabelColor } = branding

  const navClassName = navIsLight ? `${css.heroNav} ${css.heroNavLight}` : css.heroNav
  const navStyle = navBackground ? { backgroundColor: navBackground } : {}
  const labelStyle = navLabelColor ? { color: navLabelColor } : {}

  return (
    <div className={navClassName} style={navStyle}>
      <div className={css.heroPartner}>
        {logoUrl && (
          <img
            src={logoUrl}
            alt={`${institutionName} logo`}
            className={css.heroLogo}
          />
        )}
        {displayName && (
          <span className={css.heroInstitutionName} style={labelStyle}>
            {institutionName}
          </span>
        )}
      </div>
      <a
        href='https://www.ncfdd.org'
        className={css.heroNcfdd}
        target='_blank'
        rel='noopener noreferrer'
      >
        <span className={css.heroNcfddLabel} style={labelStyle}>{poweredByText || 'In partnership with'}</span>
        <img
          src={ncfddLogo}
          alt='NCFDD'
          className={css.heroNcfddLogo}
        />
      </a>
    </div>
  )
}

InstitutionHero.propTypes = {
  logoUrl: PropTypes.string,
  institutionName: PropTypes.string.isRequired,
  branding: PropTypes.shape({
    navBackground: PropTypes.string,
    navIsLight: PropTypes.bool,
    ncfddLogo: PropTypes.string,
    navLabelColor: PropTypes.string
  }),
  showInstitutionName: PropTypes.bool,
  poweredByText: PropTypes.string
}

export default InstitutionHero
